import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Typography } from '@material-ui/core';
import { Form } from '@unform/web';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import {
  Input,
  Combobox,
  DateTime,
  Autocomplete,
  Select,
  Hidden,
} from '~/components/Form';
import { ConfirmationDialogRawNew } from '~/componentsLocal';
import { t } from '~/helpers';
import api from '~/services/api';
import { deletarClienteOperacaoLubrificacao } from '~/store/modules/operacaoLubrificacao/actions';

import * as S from './styles';

export default function CreateOrUpdate({
  reference,
  data,
  create,
  toggleLoading,
}) {
  const dispatch = useDispatch();

  const [veiculo, setVeiculo] = useState(null);
  const [idProduto, setIdProduto] = useState(0);

  const [compartments, setCompartments] = useState([]);
  const { client } = useSelector((state) => state.user.profile);
  const {
    exibeoslubrificacao,
    internounidatausuario,
    exibefrascolubrificacao,
  } = useSelector((state) => state.user.configs);
  const { loading, find, params } = useSelector(
    (state) => state.operacaoLubrificacao
  );

  const [idTipoMovimentacao, setIdTipoMovimentacao] = useState(0);

  const initials = create ? data : { ...find, ...data };

  // ConfirmationDialogRaw o registro do geral
  const [isLoading, setIsLoading] = useState(false);
  const [
    tituloConfirmationDialogRaw,
    setTituloConfirmationDialogRaw,
  ] = React.useState('Deseja excluir o registro');
  const [
    mensagemConfirmationDialogRaw,
    setMensagemConfirmationDialogRaw,
  ] = React.useState('Confirma exclusão do registro?');
  const [
    openConfirmationDialogRaw,
    setOpenConfirmationDialogRaw,
  ] = React.useState(false);
  const [
    valueConfirmationDialogRaw,
    setValueConfirmationDialogRaw,
  ] = React.useState('CLICK-OK');
  const [paramSubmit, setParamSubmit] = React.useState();

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        justificativa:
          idTipoMovimentacao !== 0
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(10, t('s.geral.validacao.tamanhominimo').replace('%s', 10))
                .max(
                  255,
                  t('s.geral.validacao.tamanhomaximo').replace('%s', 255)
                )
            : Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
      const { datahorainicialmovimentacao, datahorafinalmovimentacao } = param;
      const objParam = { ...param };
      const objSend = {
        volumepredeterminadomovimentacao: '100',
        modomovimentacao: '0',
        formaidmovimentacao: '0',
        idmovimentacao: '0',
        tipomovimentacao: '0',
        numerologmovimentacao: '0',
        onlinemovimentacao: '0',
        precounitariomovimentacao: '0.0',
        vazaomediamovimentacao: '0.0',
        vazaomaximamovimentacao: '0.0',
        idcentrocusto: '',
        idcontrato: '',
        totalizadoranteriormovimentacaoabastecimento: '0.0',
        totalizador2anteriormovimentacaoabastecimento: '0.0',
        totalizadorconfirmadomovimentacaoabastecimento: '0.0',
        contingenciamovimentacaoabastecimento: '0',
        ...initials,
        ...objParam,
        datahorainicialmovimentacao,
        datahorafinalmovimentacao,
        idcliente: client,
        idoperacao: initials.idoperacao,
        idcausamanutencao: initials.idcausamanutencao,
      };
      await dispatch(deletarClienteOperacaoLubrificacao(objSend, params));
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  const getCompartiments = useCallback(async (vehicle, product) => {
    try {
      await toggleLoading(true);
      const response = await api.get('veiculoscompartimentos', {
        params: {
          wherefield: ['idveiculo', 'idproduto'],
          typewherefield: ['EQUALS', 'EQUALS'],
          valuewherefield: [vehicle, product],
          pesquisalista: true,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });

      if (response.data.items) {
        setCompartments(
          response.data.items.map((i) => ({
            label: `${i.idcompartimento} - ${i.descricaocompartimento}`,
            value: i.idcompartimento,
          }))
        );
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      await toggleLoading(false);
    }
  }, []);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      const { idveiculo, idproduto, tipomovimentacao } = find;

      if (!create) {
        setIdTipoMovimentacao(tipomovimentacao || 0);
        if (idveiculo && idproduto) getCompartiments(idveiculo, idproduto);
      }
    }

    return function cleanup() {
      mounted = false;
    };
  }, [find]);

  useEffect(() => {
    if (veiculo && idProduto) {
      getCompartiments(veiculo, idProduto);
    }
  }, [veiculo, idProduto]);

  const execHandleConfirmar = async (param) => {
    setParamSubmit(param);
    setOpenConfirmationDialogRaw(true);
  };

  async function handleSubmitPegunta(param) {
    try {
      const schema = Yup.object().shape({
        justificativa:
          idTipoMovimentacao !== 0
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(10, t('s.geral.validacao.tamanhominimo').replace('%s', 10))
                .max(
                  300,
                  t('s.geral.validacao.tamanhomaximo').replace('%s', 300)
                )
            : Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      await setIsLoading(true);
      await execHandleConfirmar(param);
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  const handleConfirmationDialogRaw = (newValue) => {
    // console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (newValue) {
      setValueConfirmationDialogRaw(newValue);
      setIsLoading(false);
      if (newValue === 'CLICK-OK') {
        setIsLoading(true);
        handleSubmit(paramSubmit);
      }
    } else {
      // cancelarAcao();
      setIsLoading(false);
    }
  };

  return (
    <>
      <>
        {' '}
        {/* <> Para confirmação do form */}
        <ConfirmationDialogRawNew
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Sim"
          textoBtnCancel="Não"
          modal="sm"
        />
      </>{' '}
      {/* <> Para confirmação do form */}
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form
          ref={reference}
          initialData={initials}
          onSubmit={(event) => handleSubmitPegunta(event)}
        >
          <S.Header>
            <Typography variant="h6">
              Exclusão de registro pelo usuário
            </Typography>
          </S.Header>

          {idTipoMovimentacao === 0 ? (
            <>
              <S.Header>
                <Typography variant="h7" color="primary">
                  ATENÇÃO: Este registro é manual
                </Typography>
              </S.Header>
              <Hidden
                name="justificativa"
                label="Justificativa"
                value="Registro é manual"
              />
            </>
          ) : (
            <>
              <S.Header>
                <Typography variant="h7" color="error">
                  ATENÇÃO: Este registro foi gerado pelo terminal
                </Typography>
              </S.Header>
              <Input
                multiline
                name="justificativa"
                label="Justificativa"
                rows={4}
              />
            </>
          )}

          {idTipoMovimentacao === 0 ? (
            <S.Header>
              <Typography variant="h5" color="primary" />
            </S.Header>
          ) : (
            <>
              <Autocomplete
                name="idposto"
                disabled
                disableClearable={!create}
                label="nomeposto"
                url="postoscomboios"
                unique="idposto"
                title={t('s.menu.configuracao.posto')}
                getValue={(value) => {
                  // handleChangepostoscomboios(value);
                  // if (value.idposto) {
                  //   setPosto(value.idposto);
                  // } else {
                  //   setPosto(0);
                  // }
                }}
              />

              <Combobox
                disabled
                name="idbico"
                label="bicoprodutobico"
                url="bicos"
                unique="idbico"
                title={t('s.menu.configuracao.bico')}
                hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                params={{
                  wherefield: 'idposto',
                  valuewherefield: data.idposto,
                  typewherefield: 'EQUALS',
                  fieldlist:
                    'idbico, idterminal, idproduto, bicoprodutobico, tipoproduto, exibemotoristaterminal',
                }}
              />

              <DateTime
                time
                name="datahorainicialmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.datahorainicialmovimentacao'
                )}
              />

              <DateTime
                time
                name="datahorafinalmovimentacao"
                disabled
                label={t('s.operacao.abastecimento.datahorafinalmovimentacao')}
              />

              <Input
                name="idveiculo"
                disabled
                onInputChange={(event, newValue) => {
                  setVeiculo(newValue);
                }}
                onChange={(event) => setVeiculo(event.target.value)}
                label={t('s.operacao.abastecimento.idveiculo')}
                getValue={(value) => setVeiculo(value)}
              />

              <Input
                name="encerranteinicialmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.encerranteinicialmovimentacao'
                )}
                type="number"
              />

              <Input
                name="encerrantefinalmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.encerrantefinalmovimentacao'
                )}
                type="number"
              />

              <Input
                name="volumemovimentacao"
                disabled
                label={t('s.operacao.abastecimento.volumemovimentacao')}
                type="number"
              />
            </>
          )}
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
